import React, { lazy, Suspense, useEffect, useState } from "react";
import ReactDOM from 'react-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter } from "react-router-dom";
import './index.css';
import { CookieSetting } from "cookiesetting-component";
import App from './App';
import reportWebVitals from './reportWebVitals';
import { HyperlinkProvider } from "./context/HyperlinkProvider";

const location = window.location.pathname.toLowerCase();
console.log(location);
const baseName = process.env.REACT_APP_BASENAME;

let basePath = baseName;
if (baseName === "/january2024") {
  basePath = basePath + "/";
}

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
    <HyperlinkProvider>
      {location === baseName || location === "/january2024/" ? <App /> : ""}
      {location !== baseName && location !== "/january2024/" ? (
        <App />
         ) : (
        ""
      )}
      </HyperlinkProvider>
    </BrowserRouter>
    <CookieSetting
      privacyPolicyLink={process.env.REACT_APP_PRIVACY_POLICY_LINK}
      configUrl={process.env.REACT_APP_COOKIE_SETTING_JSON}
      analytics={process.env.REACT_APP_ANALYTICS_PATH}
    />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
